export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGIN_GET_SCHOOLS = 'LOGIN_GET_SCHOOLS';
export const LOGIN_GET_SCHOOLS_SUCCESS = 'LOGIN_GET_SCHOOLS_SUCCESS';
export const LOGIN_GET_SCHOOLS_FAILURE = 'LOGIN_GET_SCHOOLS_FAILURE';